import LegalLayout, { Section, Card, Grid, InfoBox, ContactCTA } from "@/components/chalky/LegalLayout"

interface Props {
  last_updated: string
}

export default function MentionsLegales({ last_updated }: Props) {
  return (
    <LegalLayout
      title="Mentions"
      titleHighlight="Légales"
      subtitle="Informations légales obligatoires concernant le site chalky.fr et la société CHALKY EURL"
      lastUpdated={last_updated}
    >
      <Section number="1" title="Éditeur du site">
        <Grid>
          <Card>
            <div className="space-y-4">
              <div>
                <p className="text-xs uppercase text-slate-500 font-medium mb-1">Raison sociale</p>
                <p className="text-slate-200">CHALKY</p>
              </div>
              <div>
                <p className="text-xs uppercase text-slate-500 font-medium mb-1">Forme juridique</p>
                <p className="text-slate-200">EURL (Entreprise Unipersonnelle à Responsabilité Limitée)</p>
              </div>
              <div>
                <p className="text-xs uppercase text-slate-500 font-medium mb-1">Capital social</p>
                <p className="text-slate-200">1 000 € (Mille euros)</p>
              </div>
            </div>
          </Card>
          <Card>
            <div className="space-y-4">
              <div>
                <p className="text-xs uppercase text-slate-500 font-medium mb-1">Gérant</p>
                <p className="text-slate-200">Florent Guilbaud</p>
              </div>
              <div>
                <p className="text-xs uppercase text-slate-500 font-medium mb-1">SIRET</p>
                <p className="text-slate-200">93435243600011</p>
              </div>
              <div>
                <p className="text-xs uppercase text-slate-500 font-medium mb-1">Siège social</p>
                <p className="text-slate-200">26 B rue Aristide Briand<br />44230 Saint-Sébastien-sur-Loire, France</p>
              </div>
            </div>
          </Card>
        </Grid>
      </Section>

      <Section number="2" title="Coordonnées">
        <Grid cols={3}>
          <Card className="text-center">
            <i className="fa-solid fa-envelope text-slate-500 mb-3 text-lg block" />
            <p className="text-xs uppercase text-slate-500 font-medium mb-2">E-mail</p>
            <a href="mailto:hello@chalky.fr" className="text-slate-200 hover:text-white transition-colors">
              hello@chalky.fr
            </a>
          </Card>
          <Card className="text-center">
            <i className="fa-solid fa-phone text-slate-500 mb-3 text-lg block" />
            <p className="text-xs uppercase text-slate-500 font-medium mb-2">Téléphone</p>
            <p className="text-slate-200">+33 6 74 23 60 80</p>
          </Card>
          <Card className="text-center">
            <i className="fa-solid fa-location-dot text-slate-500 mb-3 text-lg block" />
            <p className="text-xs uppercase text-slate-500 font-medium mb-2">Adresse</p>
            <p className="text-slate-300 text-sm">26 B rue Aristide Briand<br />44230 Saint-Sébastien-sur-Loire</p>
          </Card>
        </Grid>
      </Section>

      <Section number="3" title="Hébergement">
        <Card>
          <Grid>
            <div className="space-y-3">
              <div>
                <p className="text-xs uppercase text-slate-500 font-medium mb-1">Hébergeur</p>
                <p className="text-slate-200">Clever Cloud SAS</p>
              </div>
              <div>
                <p className="text-xs uppercase text-slate-500 font-medium mb-1">Adresse</p>
                <p className="text-slate-200">4 rue Voltaire, 44000 Nantes, France</p>
              </div>
            </div>
            <div className="space-y-3">
              <div>
                <p className="text-xs uppercase text-slate-500 font-medium mb-1">Site web</p>
                <a href="https://www.clever-cloud.com" target="_blank" rel="noopener noreferrer" className="text-slate-200 hover:text-white transition-colors">
                  www.clever-cloud.com
                </a>
              </div>
              <div>
                <p className="text-xs uppercase text-slate-500 font-medium mb-1">SIRET</p>
                <p className="text-slate-200">524 172 699 00034</p>
              </div>
            </div>
          </Grid>
        </Card>
      </Section>

      <Section number="4" title="Directeur de publication">
        <Card className="text-center max-w-sm mx-auto">
          <i className="fa-solid fa-user text-slate-500 mb-3 text-lg block" />
          <p className="text-lg font-semibold text-white mb-1">Florent Guilbaud</p>
          <p className="text-slate-400 text-sm">Gérant de CHALKY EURL</p>
          <p className="text-slate-500 text-sm mt-1">Responsable des contenus publiés</p>
        </Card>
      </Section>

      <Section number="5" title="Propriété intellectuelle">
        <p className="text-slate-400 mb-6">
          L'ensemble du contenu de ce site (textes, images, vidéos, logos, icônes, sons, plans, dessins, etc.) est protégé par les droits de propriété intellectuelle.
        </p>
        <Grid>
          <Card>
            <p className="font-medium text-white mb-2">
              <i className="fa-solid fa-ban text-slate-500 mr-2" />
              Reproduction interdite
            </p>
            <p className="text-sm text-slate-400">Toute reproduction totale ou partielle sans autorisation est strictement interdite.</p>
          </Card>
          <Card>
            <p className="font-medium text-white mb-2">
              <i className="fa-solid fa-check text-slate-500 mr-2" />
              Usage personnel autorisé
            </p>
            <p className="text-sm text-slate-400">Consultation et copie privée pour usage personnel uniquement.</p>
          </Card>
        </Grid>
        <InfoBox icon="fa-solid fa-scale-balanced" title="Droits d'auteur">
          Tous les éléments de ce site sont la propriété exclusive de CHALKY EURL ou font l'objet d'une autorisation d'utilisation.
        </InfoBox>
      </Section>

      <Section number="6" title="Responsabilité et disclaimer">
        <p className="text-slate-400 mb-4">CHALKY s'efforce d'assurer l'exactitude et la mise à jour des informations diffusées sur ce site. Cependant :</p>
        <ul className="list-disc pl-6 space-y-2 text-slate-400 mb-6">
          <li>Les informations sont données à titre indicatif et peuvent évoluer</li>
          <li>CHALKY ne peut garantir l'absence d'erreurs ou d'omissions</li>
          <li>L'utilisation des informations se fait sous votre responsabilité</li>
          <li>CHALKY ne peut être tenu responsable des dommages indirects</li>
        </ul>
        <InfoBox icon="fa-solid fa-triangle-exclamation" title="Clause de non-responsabilité">
          L'utilisateur reconnaît utiliser ces informations sous sa propre responsabilité et dégage CHALKY de toute responsabilité à ce titre.
        </InfoBox>
      </Section>

      <Section number="7" title="Liens hypertextes">
        <p className="text-slate-400 mb-6">
          Ce site peut contenir des liens vers d'autres sites web. CHALKY n'exerce aucun contrôle sur ces sites et décline toute responsabilité quant à leur contenu.
        </p>
        <Grid>
          <Card>
            <p className="font-medium text-white mb-2">
              <i className="fa-solid fa-arrow-up-right-from-square text-slate-500 mr-2" />
              Liens sortants
            </p>
            <p className="text-sm text-slate-400">Les liens vers des sites externes sont fournis à titre informatif uniquement.</p>
          </Card>
          <Card>
            <p className="font-medium text-white mb-2">
              <i className="fa-solid fa-link text-slate-500 mr-2" />
              Demande de lien
            </p>
            <p className="text-sm text-slate-400">Tout lien vers notre site doit faire l'objet d'une autorisation préalable.</p>
          </Card>
        </Grid>
      </Section>

      <Section number="8" title="Cookies et collecte de données">
        <p className="text-slate-400 mb-6">
          Ce site peut utiliser des cookies pour améliorer l'expérience utilisateur et réaliser des statistiques de visite.
        </p>
        <InfoBox icon="fa-solid fa-circle-info">
          Pour plus d'informations sur notre utilisation des cookies et la gestion de vos données personnelles, consultez notre{" "}
          <a href="/confidentiality" className="text-slate-200 hover:text-white underline">Politique de confidentialité</a>.
        </InfoBox>
      </Section>

      <Section number="9" title="Droit applicable et juridiction">
        <Grid>
          <Card>
            <p className="font-medium text-white mb-3">
              <i className="fa-solid fa-scale-balanced text-slate-500 mr-2" />
              Droit applicable
            </p>
            <p className="text-slate-400 text-sm">Les présentes mentions légales sont soumises au droit français.</p>
          </Card>
          <Card>
            <p className="font-medium text-white mb-3">
              <i className="fa-solid fa-building-columns text-slate-500 mr-2" />
              Juridiction compétente
            </p>
            <p className="text-slate-400 text-sm">En cas de litige, les tribunaux de Nantes seront seuls compétents.</p>
          </Card>
        </Grid>
        <InfoBox icon="fa-solid fa-handshake" title="Règlement des différends">
          En cas de différend, nous privilégions la résolution amiable. À défaut d'accord, le litige sera porté devant les tribunaux compétents de Nantes.
        </InfoBox>
      </Section>

      <ContactCTA
        title="Questions sur nos mentions légales ?"
        subtitle="Notre équipe est disponible pour répondre à vos questions."
        secondaryHref="/confidentiality"
        secondaryLabel="Confidentialité"
      />
    </LegalLayout>
  )
}
